import React from 'react';
import { BaseRoutes } from 'App/router';

const App = () => {
  return (
    <React.StrictMode>
      <BaseRoutes />
    </React.StrictMode>
  );
};

export default App;
